/**
 * snippets — Copy-Paste-Codes fuer Firmen-Websites (Tracking, Embed, Pixel).
 */
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const buildTrackingSnippet = (companyId) => `<!-- InvictaFlow Tracking-Snippet: auf ALLEN Seiten einbinden (vor </body>) -->
<script>
(function(){
var B="${API}/t/${companyId}";
var p=new URLSearchParams(location.search);
["gclid","gbraid","wbraid","fbclid","utm_source","utm_medium","utm_campaign","utm_content","utm_term"].forEach(function(k){var v=p.get(k);if(v){try{localStorage.setItem("ifx_"+k,v);localStorage.setItem("ifx_landing",location.href);}catch(e){}}});
var vid="",nv=false;
try{vid=localStorage.getItem("ifx_vid");if(!vid){vid=Math.random().toString(36).slice(2)+Date.now().toString(36);localStorage.setItem("ifx_vid",vid);nv=true;}}catch(e){vid="anon-"+Date.now();}
function g(k){var v="";try{v=localStorage.getItem("ifx_"+k)||"";}catch(e){}return v||p.get(k)||"";}
function send(d){
d.vid=vid;d.nv=nv;d.url=location.href;d.path=location.pathname;d.ref=document.referrer||"";
["gclid","gbraid","wbraid","fbclid"].forEach(function(k){var v=g(k);if(v)d[k]=v;});
["utm_source","utm_medium","utm_campaign","utm_content","utm_term"].forEach(function(k){var v=p.get(k)||(d.t==="lead"?g(k):"");if(v)d[k]=v;});
var s=JSON.stringify(d);
try{if(navigator.sendBeacon&&navigator.sendBeacon(B,new Blob([s],{type:"text/plain"})))return;}catch(e){}
try{fetch(B,{method:"POST",body:s,keepalive:true});}catch(e){}}
send({t:"pv"});
window.ifxLead=function(d){d=d||{};d.t="lead";send(d);};
window.ifxEvent=function(n,d){d=d||{};d.t="event";d.name=n;send(d);};
document.addEventListener("submit",function(ev){
try{
var f=ev.target;if(!f||f.tagName!=="FORM")return;
var d={t:"lead",form:f.id||f.name||f.getAttribute("action")||"form",name:"",email:"",phone:"",message:"",consent:false};
var els=f.querySelectorAll("input,textarea");
for(var i=0;i<els.length;i++){
var el=els[i];var v=(el.value||"").trim();var n=((el.name||"")+" "+(el.id||"")).toLowerCase();
if(el.type==="checkbox"&&el.checked&&/consent|datenschutz|privacy|agb|zustimm|einwillig/.test(n)){d.consent=true;continue;}
if(!v)continue;
if(/(firma|company|unternehmen|gesellschaft)/.test(n)){d.company=v;}
else if(el.type==="email"||/^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$/.test(v)){d.email=d.email||v;}
else if(el.type==="tel"||/(tel|phone|handy|mobil|natel)/.test(n)){d.phone=d.phone||v;}
else if(/(name|vorname|nachname|firstname|lastname)/.test(n)){d.name=(d.name+" "+v).trim();}
else if(el.tagName==="TEXTAREA"){d.message=v.slice(0,500);}
}
if(d.email||d.phone)send(d);
}catch(e){}
},true);
})();
</script>`;

export const buildEmbedSnippet = (companyId) => {
  const formUrl = `${window.location.origin}/anfrage/${companyId}`;
  return `<!-- InvictaFlow Lead-Formular -->
<div id="invictaflow-lead-form"></div>
<script>
(function(){
  var p = new URLSearchParams(window.location.search);
  var q = new URLSearchParams({embed:"1"});
  var lg = ""; try { lg = localStorage.getItem("ifx_landing") || ""; } catch(e) {}
  q.set("page_url", lg || window.location.href);
  ["gclid","gbraid","wbraid","fbclid"].forEach(function(k){
    var v = p.get(k); if(!v){ try { v = localStorage.getItem("ifx_"+k); } catch(e) {} }
    if(v) q.set(k, v);
  });
  var f = document.createElement("iframe");
  f.src = "${formUrl}?" + q.toString();
  f.style.cssText = "width:100%;max-width:520px;height:560px;border:0;display:block";
  f.loading = "lazy";
  f.title = "Anfrage-Formular";
  document.getElementById("invictaflow-lead-form").appendChild(f);
})();
</script>`;
};

export const buildPixelSnippet = (pixelId) => `<!-- Meta Pixel Basiscode: im <head> auf allen Seiten einbinden -->
<script>
!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
document,'script','https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${pixelId || "DEINE_PIXEL_ID"}');
fbq('track', 'PageView');
</script>`;
